import {AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {ReporteEvaluacionDetalleComponent} from "./evaluaciondetalle/evaluaciondetalle.component";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import { PuestoColaborador } from "@modelo/proceso/reportepuesto.model";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";


@Component({
    selector: 'reporteevaluacion',
    templateUrl: './evaluacion.component.html',
    styleUrls: ['./evaluacion.component.scss']
})

export class ReporteEvaluacionComponent implements AfterViewInit {
    dataTable!: any;
    infopersona: PuestoColaborador;
    dataTableFaltante!: any;
    consulta!: boolean;
    organigrama: any;
    verdetalle: boolean = false;
    selectedTreeItem: {itemData: any};
    listaperiodoevaluacion: any[];
    info:any[];
    info2:any[];
    periodoevaluacion: number = 0;
    periodoevaluacionid: number = 0;

    @ViewChild("evaluaciondetalle", {read: ViewContainerRef}) evaluaciondetalle!: ViewContainerRef;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.infopersona = new PuestoColaborador();
        this.selectedTreeItem = {itemData: {}};
        this.listaperiodoevaluacion = [];
        this.info = [];
        this.info2 = [];
    }

    ngAfterViewInit() {
        this.SetPeriodoevaluacion();
    }

    cargardatos(e: any) {
        // Limpiar toda la información visible
        this.limpiarInformacion();

        if (e) {
            this.periodoevaluacionid = e;
            this.departamento();
        }
    }

    limpiarInformacion() {
        // Limpiar organigrama
        this.organigrama = null;

        // Limpiar información del usuario seleccionado
        this.info = [];
        this.infopersona = new PuestoColaborador();
        this.selectedTreeItem = {itemData: {}};
        this.verdetalle = false;

        // Limpiar componente de detalle si está visible
        if (this.evaluaciondetalle) {
            this.evaluaciondetalle.clear();
        }
        this.consulta = false;
    }

    SetPeriodoevaluacion() {
        this.appService.Post("planeacion/periodoevaluacion/buscar", {}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.listaperiodoevaluacion = res.data;
                this.periodoevaluacion = this.listaperiodoevaluacion[0].periodoevaluacionid;
                this.cargardatos(this.listaperiodoevaluacion[0].periodoevaluacionid);
            }
        });
    }

    departamento() {
        this.appService.Post("reporte/evaluacion/departamentobuscar", {"periodoevaluacionid": this.periodoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.organigrama = res.data;
                this.info = [];
                this.infopersona = new PuestoColaborador();
            }
        })
    }

    EvaluacionDetalle() {
        this.consulta = true;
        this.evaluaciondetalle.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ReporteEvaluacionDetalleComponent);
        var ref: ComponentRef<any> = this.evaluaciondetalle.createComponent(factory);
        ref.instance.entidad = this.infopersona;
        ref.instance.periodoevaluacion = this.listaperiodoevaluacion.find(x=> this.periodoevaluacionid == x.periodoevaluacionid);
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    selectItem(e: any) {
        this.info = [];
        this.infopersona = new PuestoColaborador();
        this.selectedTreeItem = e;
        let info;
        let data = e.itemData;
        switch (data.tipo) {
            case 1:
                info = new PuestoColaborador(data.obj);
                this.verdetalle = false;
                break;
            case 2:
                info = new PuestoColaborador(data.obj);
                this.verdetalle = true;
                break;
        }
        this.DatosPregunta(info);
    }

    DatosPregunta(data: any) {
        this.infopersona = data;
        this.appService.Post("reporte/evaluacion/preguntacolaborador", {"entidad": data, "periodoevaluacionid": this.periodoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.info = res.data;
            }
        })
    }
}
